import React from 'react';
import UIContainer from 'components/ui/UIContainer';
import AchievementsContent from './AchievementsContent';

const AchievementsPage: React.FC = () => (
  <UIContainer sx={{ mb: 8, mt: 3 }}>
    <AchievementsContent />
  </UIContainer>
);

export default AchievementsPage;
